import gql from 'graphql-tag'

export const UPDATE_MESSAGE = gql`
  mutation updateMessage($data: MessagesUpdateInput!, $where: MessagesWhereUniqueInput!) {
    updateMessage(data: $data, where: $where) {
      id
      imageUrl
    }
  }
`

export const SEND_MANUAL_BIRTHDAY_NOTIFICATION = gql`
  mutation sendManualBirthdayNotification($userId: ID!) {
    sendManualBirthdayNotification(userId: $userId)
  }
`

export const MARK_BIRTHDAY_POPUP_VISITED = gql`
  mutation markBirthdayPopupVisited {
    markBirthdayPopupVisited
  }
`

export const UPLOAD_BIRTHDAY_IMAGE = gql`
  mutation uploadBirthdayImage($file: Upload!) {
    uploadBirthdayImage(file: $file)
  }
`
